// The edit panel's form: its shape, what counts as a change, and what is sent.
export const DEFAULT_LIMITS = { question: 150, answer: 350, alts: 5, alt: 100, attachments: 3, label: 60 }

export function formFromEntry(entry) {
  return {
    question: entry?.question ?? '',
    answer: entry?.answer ?? '',
    alts: [...(entry?.alt_phrasings ?? [])],
    group_id: entry?.group?.id ?? '',
    links: (entry?.attachments ?? []).map((link) => ({ url: link.url ?? '', label: link.label ?? '' })),
  }
}

// Empty link rows are not attachments.
const attachments = (links) => links
  .filter((link) => link.url.trim() || link.label.trim())
  .map((link) => ({ type: 'link', url: link.url.trim(), label: link.label.trim() }))

export function contentFromForm(form) {
  return {
    question: form.question,
    answer: form.answer,
    alt_phrasings: form.alts,
    attachments: attachments(form.links),
    group_id: form.group_id || null,
  }
}

// For a PATCH: only what differs from the stored entry.
export function changedFields(form, entry) {
  const before = contentFromForm(formFromEntry(entry))
  const after = contentFromForm(form)
  return Object.fromEntries(
    Object.keys(after).filter((name) => JSON.stringify(after[name]) !== JSON.stringify(before[name]))
      .map((name) => [name, after[name]]),
  )
}

export function isDirty(form, entry) {
  return JSON.stringify(contentFromForm(form)) !== JSON.stringify(contentFromForm(formFromEntry(entry)))
}

// Adds a phrasing unless it is empty, a repeat (case and spacing aside), or past the cap.
export function addAlt(alts, text, max) {
  const value = text.trim().replace(/\s+/g, ' ')
  const same = (other) => other.trim().replace(/\s+/g, ' ').toLocaleLowerCase() === value.toLocaleLowerCase()
  if (!value || alts.length >= max || alts.some(same)) return alts
  return [...alts, value]
}

// Which form field an API error belongs to (`alt_phrasings[2]`, `attachments[0].url`, `name`).
export function fieldOfError(detail) {
  const field = detail?.field || ''
  if (field.startsWith('alt_phrasings')) return 'alts'
  if (field.startsWith('attachments')) return 'links'
  if (detail?.error === 'duplicate_question') return 'question'
  return ['question', 'answer'].includes(field) ? field : 'form'
}
